import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';

export interface NewRelicBrowserConfig {
  enabled: boolean;
  accountID?: string;
  trustKey?: string;
  agentID?: string;
  licenseKey?: string;
  applicationID?: string;
  allowedOrigins?: string[];
}

const hasRuntimeValue = (value?: string): value is string =>
  typeof value === 'string' &&
  value.trim().length > 0 &&
  !value.includes('#{') &&
  !value.includes('}#') &&
  !value.includes('$(');

export function initNewRelicBrowser(config?: NewRelicBrowserConfig): void {
  if (!config?.enabled) {
    return;
  }

  const { accountID, trustKey, agentID, licenseKey, applicationID } = config;

  if (
    !hasRuntimeValue(accountID) ||
    !hasRuntimeValue(trustKey) ||
    !hasRuntimeValue(agentID) ||
    !hasRuntimeValue(licenseKey) ||
    !hasRuntimeValue(applicationID)
  ) {
    console.warn('New Relic Browser is enabled but configuration is incomplete.');
    return;
  }

  new BrowserAgent({
    init: {
      browser_consent_mode: { enabled: false },
      privacy: { cookies_enabled: true },
      distributed_tracing: {
        enabled: true,
        cors_use_newrelic_header: false,
        cors_use_tracecontext_headers: true,
        allowed_origins: config.allowedOrigins ?? [],
      },
      performance: { capture_measures: true },
      ajax: {
        deny_list: ['bam.nr-data.net'],
        capture_payloads: 'none',
      },
    },
    loader_config: {
      accountID,
      trustKey,
      agentID,
      licenseKey,
      applicationID,
    },
    info: {
      beacon: 'bam.nr-data.net',
      errorBeacon: 'bam.nr-data.net',
      licenseKey,
      applicationID,
      sa: 1,
    },
  });
}
